<template>
  <div class="seeActivityManagement">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backActivity')}}</el-button>
      </div>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.seeActivityManagementcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <el-table-column  :label="$t('lang.lab_village')">
          <template slot-scope="scope">
            <span>
              {{scope.row.garden.name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_buildingnum')">
          <template slot-scope="scope">
            <span>
              {{scope.row.garden.grids.houseName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_unitnum')">
          <template slot-scope="scope">
            <span>
              {{scope.row.garden.grids.unitName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_roomnum')">
          <template slot-scope="scope">
            <span>
              {{scope.row.garden.grids.roomName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span v-if="scope.row.garden.userType === 1">{{$t('lang.lab_isOwner')}}</span>
            <span v-if="scope.row.garden.userType === 2">{{$t('lang.lab_isFamilyMembers')}}</span>
            <span v-if="scope.row.garden.userType === 3">{{$t('lang.lab_isTenant')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">未核销</span>
            <span v-if="scope.row.status == 1" style="color:#85ce61">已核销</span>
          </template>
        </el-table-column>cerOperTime
        <el-table-column prop="cerOperTime"  label="核销时间">
          <template slot-scope="scope">{{ scope.row.cerOperTime | time }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:seeActivityManagement
 *@Description:活动管理详情
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-21
 */
export default {
  data () {
    return {
      multipleSelection: [],
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      id: '',
      seeActivityManagementcheckbox: require('@/config/enum').seeActivityManagementcheckbox, // 是否隐藏复选框
    }
  },
  created () {
    this.id = this.$route.query.id
    this.activityList()
  },
  methods: {
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
     // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
     // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 活动参加人详情列表
    activityList() {
      let loading = this.$loading()
      this.$get(
        `/activityUser?pageSize=${this.pageSize}&pageNo=${this.pageNum}&activityId=${this.id}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.activityList()
    },
    // 返回按钮
     jump() {
      this.$router.push({ name: 'activityManagementList' })
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.activityList()
    }
  }
}
</script>

<style>

</style>